export const defaultSpOptions = {
  wantedFiles: "/index.js", // mine
  template: "",
  customSetup: "", // ex: { dependencies: {react-hook-form: 'latest'}}

  hasFileExpl: false,
  advFileExpl: false,
  hasConsole: true,
  hasPreview: false,
  showNavigator: false,
  options: {
    visibleFiles: ["/index.js"],
    activeFile: "/index.js",
    autoReload: false,
    autorun: false,
  },
};
